"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyCodeScreenBase = void 0;
var react_1 = __importStar(require("react"));
var WorkflowCard_1 = require("../../components/WorkflowCard");
var WorkflowCardActions_1 = require("../../components/WorkflowCard/WorkflowCardActions");
var WorkflowCardBody_1 = require("../../components/WorkflowCard/WorkflowCardBody");
var WorkflowCardHeader_1 = require("../../components/WorkflowCard/WorkflowCardHeader");
var WorkflowCardInstructions_1 = require("../../components/WorkflowCard/WorkflowCardInstructions");
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var ErrorManager_1 = __importDefault(require("../../components/Error/ErrorManager"));
/**
 * Component that renders a screen that prompts a user to enter the confirmation code
 * that was sent to the email address that they used to register.
 *
 * @param codeValidator function that validates the code text field
 * @param onResend function that is called when the resend link/button is clicked
 * @param resendInstructions text to display ahead of the resend link/button
 * @param resendLabel text to display for the resend link/button
 * @param initialValue the initial value for the code text field
 * @param verifyCodeInputLabel the label for the code text field
 * @param errorDisplayConfig configuration for customizing how errors are displayed
 * @param WorkflowCardBaseProps props that will be passed to the WorkflowCard component
 * @param WorkflowCardHeaderProps props that will be passed to the WorkflowCardHeader component
 * @param WorkflowCardInstructionProps props that will be passed to the WorkflowCardInstructions component
 * @param WorkflowCardActionsProps props that will be passed to the WorkflowCardActions component
 * @param verifyCodeTextFieldProps props to pass to the verify code field.
 *
 * @category Component
 */
var VerifyCodeScreenBase = function (props) {
    var codeValidator = props.codeValidator, onResend = props.onResend, resendInstructions = props.resendInstructions, resendLabel = props.resendLabel, verifyCodeInputLabel = props.verifyCodeInputLabel, initialValue = props.initialValue, errorDisplayConfig = props.errorDisplayConfig, verifyCodeTextFieldProps = props.verifyCodeTextFieldProps;
    var cardBaseProps = props.WorkflowCardBaseProps || {};
    var headerProps = props.WorkflowCardHeaderProps || {};
    var instructionsProps = props.WorkflowCardInstructionProps || {};
    var actionsProps = props.WorkflowCardActionsProps || {};
    var _a = react_1.default.useState(initialValue !== null && initialValue !== void 0 ? initialValue : ''), verifyCode = _a[0], setVerifyCode = _a[1];
    var _b = react_1.default.useState(false), shouldValidateCode = _b[0], setShouldValidateCode = _b[1];
    var _c = react_1.default.useState(codeValidator ? codeValidator(initialValue !== null && initialValue !== void 0 ? initialValue : '') : false), isCodeValid = _c[0], setIsCodeValid = _c[1];
    var _d = react_1.default.useState(''), codeError = _d[0], setCodeError = _d[1];
    var handleVerifyCodeInputChange = (0, react_1.useCallback)(function (code) {
        setVerifyCode(code);
        if (codeValidator) {
            var validatorResponse = codeValidator(code);
            setIsCodeValid(typeof validatorResponse === 'boolean' ? validatorResponse : false);
            setCodeError(typeof validatorResponse === 'string' ? validatorResponse : '');
        }
    }, [codeValidator]);
    (0, react_1.useEffect)(function () {
        if (verifyCode.length > 0) {
            setShouldValidateCode(true);
            handleVerifyCodeInputChange(verifyCode);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleOnNext = function () {
        var onNext = actionsProps.onNext;
        if (onNext)
            onNext({ code: verifyCode });
    };
    var handleOnPrevious = function () {
        var onPrevious = actionsProps.onPrevious;
        if (onPrevious)
            onPrevious({ code: verifyCode });
    };
    return (react_1.default.createElement(WorkflowCard_1.WorkflowCard, __assign({}, cardBaseProps),
        react_1.default.createElement(WorkflowCardHeader_1.WorkflowCardHeader, __assign({}, headerProps)),
        react_1.default.createElement(WorkflowCardInstructions_1.WorkflowCardInstructions, __assign({}, instructionsProps)),
        react_1.default.createElement(WorkflowCardBody_1.WorkflowCardBody, null,
            react_1.default.createElement(ErrorManager_1.default, __assign({}, errorDisplayConfig),
                react_1.default.createElement(TextField_1.default, __assign({ label: verifyCodeInputLabel, fullWidth: true, value: verifyCode, variant: "filled", error: shouldValidateCode && !isCodeValid, helperText: shouldValidateCode && codeError }, verifyCodeTextFieldProps, { onBlur: function (e) {
                        // eslint-disable-next-line no-unused-expressions
                        (verifyCodeTextFieldProps === null || verifyCodeTextFieldProps === void 0 ? void 0 : verifyCodeTextFieldProps.onBlur) && verifyCodeTextFieldProps.onBlur(e);
                        setShouldValidateCode(true);
                    }, onChange: function (evt) {
                        // eslint-disable-next-line no-unused-expressions
                        (verifyCodeTextFieldProps === null || verifyCodeTextFieldProps === void 0 ? void 0 : verifyCodeTextFieldProps.onChange) && verifyCodeTextFieldProps.onChange(evt);
                        handleVerifyCodeInputChange(evt.target.value);
                    }, onKeyUp: function (e) {
                        if (e.key === 'Enter' && ((verifyCode.length > 0 && isCodeValid) || actionsProps.canGoNext))
                            handleOnNext();
                    } })),
                react_1.default.createElement(Box_1.default, { sx: { mt: 2 } },
                    react_1.default.createElement(Typography_1.default, null,
                        resendInstructions,
                        react_1.default.createElement(Typography_1.default, { sx: { fontSize: 'inherit', textTransform: 'initial', '&:hover': { cursor: 'pointer' } }, onClick: function () { return onResend === null || onResend === void 0 ? void 0 : onResend(); }, color: "primary", variant: 'button' },
                            ' ',
                            react_1.default.createElement("u", null, resendLabel)))))),
        react_1.default.createElement(WorkflowCardActions_1.WorkflowCardActions, __assign({}, actionsProps, { canGoNext: (verifyCode.length > 0 && isCodeValid && actionsProps.canGoNext), onNext: handleOnNext, onPrevious: handleOnPrevious }))));
};
exports.VerifyCodeScreenBase = VerifyCodeScreenBase;
